/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
class s{constructor(s,t){this.isDraped=s,this.domain=t}}export{s as SnappingHint};
